/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment1/view.blocks to change it.
import Add from './Add/index'
import AddAction from './AddAction/index'
import Appointment from './Appointment/index'
import IntervalToNext from './IntervalToNext/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Appointment1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment"
  
}) {
  return (<React.Fragment
>
<Appointment
  viewPath={`${viewPath}/Appointment`}
/>
<div
  data-testid="Appointment1.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<IntervalToNext
  viewPath={`${viewPath}/IntervalToNext`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<Add
  viewPath={`${viewPath}/Add`}
/>
{children}
</React.Fragment>)
}